import React from 'react';
import './Videos.scss';

const Videos: React.FC = () => {
  return (
    <section id="videos" className="videos">
      <div className="container">
        <h2>Shadow Tracker in Action</h2>
        <p>See how the Shadow Tracker works in real-world scenarios</p>
        
        <div className="video-grid">
          <div className="video-item">
            <video 
              controls 
              className="video-player"
            >
              <source src="/Movement Mode.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <h3>Movement Mode</h3>
            <p>See how Shadow Tracker detects and tracks movement in real-time</p>
          </div>
          
          <div className="video-item">
            <video 
              controls 
              className="video-player"
            >
              <source src="/Stationary Mode.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <h3>Stationary Mode</h3>
            <p>Learn about power-saving stationary mode for long-term tracking</p>
          </div>
          
          <div className="video-item">
            <video 
              controls 
              className="video-player"
            >
              <source src="/About - shop tracker video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <h3>Shop Tracker Demo</h3>
            <p>Complete walkthrough of Shadow Tracker features and setup</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Videos;
